import { render, staticRenderFns } from "./IndicesTematicosListado.vue?vue&type=template&id=13f37965&scoped=true"
import script from "./IndicesTematicosListado.vue?vue&type=script&lang=js"
export * from "./IndicesTematicosListado.vue?vue&type=script&lang=js"
import style0 from "./IndicesTematicosListado.vue?vue&type=style&index=0&id=13f37965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f37965",
  null
  
)

export default component.exports